var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c("gg-card-header", [
        _c(
          "div",
          {
            staticClass: "d-flex align-center flex-wrap"
          },
          [
            _c(
              "span",
              {
                staticClass: "mr-auto"
              },
              [_vm._v(_vm._s(_vm.title))]
            ),
            _vm._t("header-actions")
          ],
          2
        )
      ]),
      _c(
        "gg-card-text",
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.responders.data,
              loading: _vm.responders.loading_status
            },
            scopedSlots: _vm._u([
              {
                key: "item.actions",
                fn: function fn(_ref) {
                  var item = _ref.item
                  return [
                    _c(
                      "v-menu",
                      {
                        attrs: {
                          "offset-y": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "activator",
                              fn: function fn(_ref2) {
                                var on = _ref2.on,
                                  attrs = _ref2.attrs
                                return [
                                  _c(
                                    "gg-btn",
                                    _vm._g(
                                      _vm._b({}, "gg-btn", attrs, false),
                                      on
                                    ),
                                    [
                                      _vm._v(" Manage "),
                                      _c("v-icon", [_vm._v("mdi-chevron-down")])
                                    ],
                                    1
                                  )
                                ]
                              }
                            }
                          ],
                          null,
                          true
                        )
                      },
                      [
                        _c(
                          "v-list",
                          [
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.editResponder(item.email)
                                  }
                                }
                              },
                              [_c("v-list-item-title", [_vm._v(" Edit ")])],
                              1
                            ),
                            _c(
                              "v-list-item",
                              {
                                on: {
                                  click: function click($event) {
                                    return _vm.deleteResponder(item.email)
                                  }
                                }
                              },
                              [_c("v-list-item-title", [_vm._v(" Delete ")])],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm.modals.delete
        ? _c("delete-responder", {
            attrs: {
              "is-active": _vm.modals.delete,
              action: "edit",
              email: _vm.email
            },
            on: {
              close: _vm.deleteResponder
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }